/**
 * Solicitar ingreso
 *
 */
import React from 'react'
import { Button, Spin, DatePicker, Modal, Select, Input, InputNumber, Row, Popconfirm, Col, message } from 'antd'
import moment from 'moment'
import numeral from 'numeral'
import Api from '../../../Api'
import Exception from '../../../Exception'
import debounce from 'lodash.debounce'

export default class SolicitarPago extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      ordenes: [],
      entradas: [],
      especiales: [],
      search: '',
      orderId: '',
      entradaId: '',
      maxAmount: 0,
      ordenLocal: true,
      solicitudMaquinaria: false,
      form: this.defaultForm(),
    }

    this.lastOrdenesFetchId = 0
    this.lastEntradaFetchId = 0
    this.lastEspecialesFetchId = 0
    this.fetchOrdenes = debounce(this.fetchOrdenes.bind(this), 800)
    this.fetchEntradas = debounce(this.fetchEntradas.bind(this), 800)
    this.fetchEspeciales = debounce(this.fetchEspeciales.bind(this), 800)
  }

  /**
   * defaultForm
   */
  defaultForm = () => ({
    iId: null,
    iIdEntrada: null,
    iIdOrdenCompra: null,
    dImporte: 0,
    dTipoCambio: 0,
    sReferencia: '',
    sEspecial: '',
    dInicioPeriodo: null,
    dTerminoPeriodo: null,
    sConcepto: '',
  })

  /**
   * setFormValue
   *
   * @param {String} key
   * @param {Any} value
   */
  setFormValue = (key, value) => {
    this.setState({
      form: {
        ...this.state.form,
        [key]: value
      }
    })
  }

  /**
   * load
   */
  load = (id) => {
    this.setState({
      loading: true,
      visible: true,
    })

    const query = {
      __returnType: 'one',
      model: 'CxpOrdenPago',
      attributes: Object.keys(this.defaultForm()),
      include: [
        { as: 'ordenCompra', attributes: ['iId', 'sConsecutivo', 'dTipoCambio', 'dImporte', 'dImportePendientePago'],
          include: [
            { as: 'moneda', attributes: ['iLocal'] },
          ]
        },

        { as: 'requisicion', attributes: ['iMaquinaria'] },
      ],
      where: { iId: id },
    }

    Api.query(query)
      .then(({ data }) => {
        this.setState({
          loading: false,
          orderId: data.iIdOrdenCompra.toString(),
          entradaId: data.iIdEntrada ? data.iIdEntrada.toString() : '',
          maxAmount: data.ordenCompra ? data.ordenCompra.dImportePendientePago : 0,
          ordenLocal: data.ordenCompra ? data.ordenCompra.moneda.iLocal : false,
          solicitudMaquinaria: data.ordenCompra && (!!data.requisicion.iMaquinaria),
          ordenes: data.ordenCompra ? [data.ordenCompra] : [],
          especiales: data.especial ? [data.especial] : [],
          form: {
            ...this.defaultForm(),
            ...data,
          }
        })
      })
      .catch(error => {
        Exception.load(error).show()
        this.setState({ loading: false })
      })
  }

  /**
   *
   * @param {*} ordenId
   */
  fetchEntradas = (ordenId, search) => {
    this.setState({
      loading: true,
      entradas: [],
    })

    this.lastEntradaFetchId += 1
    const fetchId = this.lastEntradaFetchId

    const filter = {
      iActivo: true,
      iId_proveedor: Api.getProviderId(),
      sEstado: 'VALIDADA',
      $and: [
        { $or: [{ iId_OrdenCompra: null }] }
      ]
    }

    if (ordenId) {
      filter.$and[0].$or.push({ iId_OrdenCompra: ordenId })
    }

    if (search) {
      const likeSearch = { $like: `%${search}%` }
      filter.$and.push({
        $or: [
          { sConsecutivo: likeSearch },
          { sReferencia: likeSearch },
          // { '$ordenCompra.sConsecutivo$': likeSearch },
        ]
      })
    }

    const query = {
      model: 'AlmEntrada',
      attributes: [
        'iId',
        'sConsecutivo',
        'dTipoCambio'
      ],
      include: [
        /*{
          as: 'ordenCompra',
          where: { iActivo: true, eEstado: { $ne: 'CANCELADA' } }
        },*/
        {
          as: 'moneda',
          required: true,
          attributes: ['iLocal'],
        }
      ],
      where: filter,
    }

    Api.query(query)
      .then(response => {
        if (this.lastEntradaFetchId === fetchId) {
          this.setState({
            loading: false,
            entradas: response.data,
          })

          if (response.data.length === 0) {
            message.info('No se encontraron entradas')
          }
        }
      })
      .catch(error => {
        this.setState({ loading: false, entradas: [] })
        Exception.load(error).show()
      })
  }

  /**
   * fetch
   *
   * @param {String} search
   */
  fetchOrdenes(search = '') {
    this.setState({
      search,
      loading: true,
      ordenes: [],
    })

    this.lastOrdenesFetchId += 1
    const fetchId = this.lastOrdenesFetchId

    Api.query({
      model: 'ComOrden',
      attributes: [
        'iId',
        'sConsecutivo',
        'dTipoCambio',
        'dImporte',
        'dImportePendientePago',
      ],
      include: [
        { as: 'moneda', attributes: ['iLocal'] },
        { as: 'requisicion', attributes: ['iMaquinaria'] },
      ],
      where: {
        eEstado: 'AUTORIZADA',
        iId_proveedor: Api.getProviderId(),
        sConsecutivo: search && search.length > 0 ? { $like: `%${search.trim()}%` } : undefined
      },
      order: [['iId', 'DESC']]
    })
    .then(response => {
      if (this.lastOrdenesFetchId === fetchId) {
        this.setState({
          loading: false,
          ordenes: response.data,
        })
      }
    })
    .catch(error => {
      this.setState({ loading: false, ordenes: [] })
      Exception.load(error).show()
    })
  }

  /**
   * fetch especiales
   *
   */
  fetchEspeciales(search = '') {
    this.setState({
      search,
      loading: true,
      especiales: [],
    })

    this.lastEspecialesFetchId += 1
    const fetchId = this.lastEspecialesFetchId

    Api.query({
      model: 'AlmInsumoControlEspecial',
      attributes: [
        'iId',
        'sNumeroEconomico',
      ],
      where: {
        iIdArrendador: Api.getProviderId(),
        ...(search.trim().length ? {sNumeroEconomico: { $like: `%${search.trim()}%` }} : {})
      },
      order: [['sNumeroEconomico', 'ASC']]
    })
    .then(response => {
      if (this.lastEspecialesFetchId === fetchId) {
        this.setState({
          loading: false,
          especiales: response.data,
        })
      }
    })
    .catch(error => {
      this.setState({ loading: false, especiales: [] })
      Exception.load(error).show()
    })
  }

  /**
   * onSave
   */
  onSave = () => {
    const data = {
      ...this.state.form,
      sReferencia: this.state.form.sReferencia.trim(),
      sConcepto: this.state.form.sConcepto.trim(),
    }

    const id = this.state.form.iId
    const makeMutation = () => Api.post('/kernel/mutator', {
      model: 'CxpOrdenPago', id, values: data
    })

    const request = id ? makeMutation() : Api.post('/cxp/solicitudes-pago', data)

    request
      .then(response => {
        this.setState({ loading: false, visible: false })

        if (typeof this.props.onCreate === 'function') {
          this.props.onCreate(response.data)
        }
      })
      .catch(error => {
        this.setState({ loading: false })
        Exception.load(error).show()
      })
  }

  /**
   * onCancel
   */
  onCancel = () => {
    this.setState({ visible: false })
  }

  /**
   * showModal()
   */
  showModal() {
    this.setState({
      loading: false,
      visible: true,
      solicitudMaquinaria: false,
      search: '',
      ordenes: [],
      entradas: [],
      especiales: [],
      form: this.defaultForm(),
      orderId: null,
      entradaId: null,
    })
  }

  /**
   *
   * @param {*} orderId
   * @returns
   */
  onOrderSelected = (orderId) => {
    const id = orderId * 1

    const order = this.state.ordenes.find(item => item.iId === id)
    if (!order) { return }

    this.setState({
      orderId,
      form: {
        ...this.state.form,
        iIdOrdenCompra: id,
        dImporte: 0,
        dTipoCambio: order.dTipoCambio,
      },
      ordenLocal: !!order.moneda.iLocal,
      solicitudMaquinaria: order.requisicion
        ? !!order.requisicion.iMaquinaria
        : false,

      maxAmount: parseFloat(order.dImportePendientePago > 0 ? order.dImportePendientePago : order.dImporte),
    })

    if (orderId) {
      this.fetchEntradas(orderId)
    }
  }

  /**
   *
   * @param {*} entradaId
   */
  onEntradaSelected = (entradaId) => {
    const id = entradaId * 1

    const entrada = this.state.entradas.find(item => item.iId === id)
    if (!entrada) { return }

    this.setState({
      entradaId,
      form: {
        ...this.state.form,
        iIdEntrada: id,
        dImporte: 0,
        dTipoCambio: entrada.dTipoCambio,
      },
      ordenLocal: !!entrada.moneda.iLocal,
    })
  }

  /**
   * onOrderSelected
   *
   */
  onEspecialSeleccionado = (val) => {
    this.setState({
      form: {
        ...this.state.form,
        sEspecial: val,
      },
    })
  }

  /**
   * render
   */
  render() {
    return (
      <Modal
        title='INGRESAR A CUENTAS X PAGAR'
        style={{ maxWidth: 600, top: 20 }}
        visible={this.state.visible}
        onOk={this.onSave}
        onCancel={this.onCancel}
        footer={[
          <Button key='cancelar' onClick={this.onCancel} children='Cancelar' />,
          <Popconfirm key='guardar' title='¿Ingresar a cuentas x pagar?' onConfirm={this.onSave}>
            <Button type='primary' loading={this.state.loading} children='Aceptar' />
          </Popconfirm>,
        ]}>

        <Row style={styles.row}>
          <label>ORDEN (COMPRA / SERVICIO)</label>
          <Select
            showSearch={true}
            allowClear={true}
            style={{ width: '100%' }}
            filterOption={false}
            onChange={this.onOrderSelected}
            onSearch={this.fetchOrdenes}
            value={this.state.orderId}
            notFoundContent={this.state.loading ? <Spin size='small' /> : null}
            children={this.state.ordenes.map((item) =>
              <Select.Option key={item.iId.toString()}>{item.sConsecutivo}</Select.Option>
            )}
          />
        </Row>

        <Row style={styles.row}>
          <label>ENTRADA</label>
          <Select
            showSearch={true}
            allowClear={true}
            disabled={!this.state.orderId}
            style={{ width: '100%' }}
            filterOption={false}
            onChange={this.onEntradaSelected}
            onSearch={(search) => this.fetchEntradas(this.state.orderId, search)}
            value={this.state.entradaId}
            notFoundContent={this.state.loading ? <Spin size='small' /> : null}
            children={this.state.entradas.map((item) =>
              <Select.Option key={item.iId.toString()}>{item.sConsecutivo}</Select.Option>
            )}
          />
        </Row>

        {!this.state.solicitudMaquinaria ? null : (
          <Row style={styles.row}>
            <label>NÚMERO ECONOMICO</label>
              <Input
              style={{ width: '100%' }}
              value={this.state.form.sEspecial}
              onChange={e => this.setFormValue('sEspecial', e.target.value)}
            />
            {/* <Select
              showSearch={true}
              allowClear={true}
              style={{ width: '100%' }}
              filterOption={false}
              onChange={this.onEspecialSeleccionado}
              value={this.state.form.sEspecial}
              notFoundContent={this.state.loading ? <Spin size='small' /> : null}
              children={this.state.especiales.map((item) =>
                <Select.Option key={item.sNumeroEconomico}>{item.sNumeroEconomico}</Select.Option>
              )}
            /> */}
          </Row>
        )}

        {!this.state.solicitudMaquinaria ? null : (
          <Row style={styles.row}>
            <Col span={11}>
              <label>INICIO DE PERIODO</label>
              <DatePicker
                style={{ width: '100%' }}
                value={this.state.form.dInicioPeriodo ? moment(this.state.form.dInicioPeriodo, 'YYYY-MM-DD') : null}
                onChange={date => date ? this.setFormValue('dInicioPeriodo', date.format('YYYY-MM-DD')) : undefined}
              />
            </Col>

            <Col span={2} />

            <Col span={11}>
              <label>TERMINO DE PERIODO</label>
              <DatePicker
                style={{ width: '100%' }}
                value={this.state.form.dTerminoPeriodo ? moment(this.state.form.dTerminoPeriodo, 'YYYY-MM-DD') : null}
                onChange={date => date ? this.setFormValue('dTerminoPeriodo', date.format('YYYY-MM-DD')) : undefined}
              />
            </Col>
          </Row>
        )}

        <Row style={styles.row}>
          <label>REFERENCIA (# FACTURA)</label>
          <Input
            style={{ width: '100%' }}
            value={this.state.form.sReferencia}
            onChange={e => this.setFormValue('sReferencia', e.target.value)}
          />
        </Row>

        {this.state.ordenLocal ? null : (
          <Row style={styles.row}>
            <label>TIPO DE CAMBIO</label>
            <InputNumber
              style={{ width: '100%' }}
              value={this.state.form.dTipoCambio}
              onChange={val => this.setFormValue('dTipoCambio', val)}
            />
          </Row>
        )}

        <Row style={styles.row}>
          <label>IMPORTE A INGRESAR ({`MAX ${numeral(this.state.maxAmount).format('$0,0.000')}`})</label>
          <InputNumber
            style={{ width: '100%' }}
            value={this.state.form.dImporte}
            onChange={val => this.setFormValue('dImporte', val)}
          />
        </Row>

        <Row style={styles.row}>
          <label>CONCEPTO</label>
          <Input.TextArea
            rows={3}
            value={this.state.form.sConcepto}
            onChange={e => this.setFormValue('sConcepto', e.target.value.toUpperCase())}
          />
        </Row>
      </Modal>
    )
  }
}

const styles = {
  row: {
    marginBottom: 10,
  }
}
